import api from './index';

let exports = {};

// 从工程师服务能力 - 获取servcType
exports.getServcTypesFromServicerEngineer = function (data, callback) {
    api.post('/engi/strategy/engineer/servc/servcTypes/get')
    .data(data)
    .done(callback)
    .go();
};

// 从工程师服务能力 - 获取servcType
exports.getEngineerServcPageList = function (data, callback) {
    api.post('/engi/strategy/engineer/servc/paged/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取工程师及门店能力列表
exports.getServicerEngineerList = function (data, callback) {
    api.post('/engi/strategy/engineer/and/shop/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取工程师_服务能力分页列表
exports.getEngineerAndServcList = function (data, result) {
    api.post('/engi/strategy/engineer/and/servc/list/get')
    .data(data)
    .done(result)
    .go()
};

exports.getServcTypesFromEngineerDevcServc = function (data, result) {
    api.post('/engi/strategy/engineer/devc/servc/servcTypes/get')
    .data(data)
    .done(result)
    .go()
};

// 获取工程师_设备服务能力分页列表
exports.getEngineerDevcServcList = function (data, result) {
    api.post('/engi/strategy/engineer/devc/servc/list/get')
    .data(data)
    .done(result)
    .go()
};

// 获取工程师_设备分类能力分页列表
exports.getEngineerDevcCatList = function (data, result) {
    api.post('/engi/strategy/engineer/devc/cat/list/get')
    .data(data)
    .done(result)
    .go()
};

// 获取工程师门店设备分类能力列表
exports.getEngineerShopDevcCatsByFilter = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/devc/cat/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取工程师门店设备分类能力列表
exports.getEngineerShopsByFilter = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取服务商工程师网点负责门店
exports.getServicerEngineerSiteShop = function (data, callback) {
    api.post('/engi/strategy/engineer/site/shop/list/get')
        .data(data)
        .done(callback)
        .go();
};

// 批量保存工程师门店信息
exports.saveEngineerShopList = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存工程师门店信息(分类（服务）、纯服务)
exports.saveEngineerShop = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存工程师_门店设备分类能力(分类（服务）)
exports.saveEngineerShopDevcCat = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/devc/cat/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 删除工程师_门店
exports.deleteEngineerShop = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除工程师_门店分类
exports.deleteEngineerShopDevcCat = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/devc/cat/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除工程师_门店分类服务
exports.deleteEngineerShopDevcServc = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/devc/Servc/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除工程师_门店服务
exports.deleteEngineerShopServc = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/Servc/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取工程师及门店服务能力列表
exports.getEngineerShopServcList = function (data, callback) {
    api.get('/engi/strategy/engineer/shop/servc/list/get')
    .params(data)
    .done(callback)
    .go();
};
// 修改工程师
exports.doUpdateEngineerShopEnginnerId = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/update/engineerId/do')
    .data(data)
    .done(callback)
    .go();
};
// 修改工程师
exports.checkEngineerShopEnginnerId = function (data, callback) {
    api.post('/engi/strategy/engineer/shop/check/engineerId')
    .data(data)
    .done(callback)
    .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/engiStrategy.js
// module id = 98
// module chunks = 1